// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButtonTheme__button--2_JrU","expanded":"MenuButtonTheme__expanded--JdFRF"};